import React from "react";

const HVACAbout = () => {
  return (
    <div className="min-h-screen bg-black text-gray-200 px-4 py-6 md:px-10">
      
      {/* Header */}
      <header className="mb-8">
        <h1 className="text-xl lg:text-2xl font-bold text-yellow-200 flex items-center gap-3">
          <i className="fa-solid fa-wind text-cyan-400"></i>
          HVAC Sector
        </h1>
        <p className="mt-3 text-xs lg:text-sm text-gray-400 leading-relaxed">
          Heating, Ventilation & Air Conditioning — the invisible backbone of
          comfort, health, productivity, and sustainability.
        </p>
      </header>

      {/* What is HVAC */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-white flex items-center gap-2 mb-3">
          <i className="fa-solid fa-circle-info text-blue-400"></i>
          What is HVAC?
        </h2>
        <p className="text-sm leading-relaxed text-gray-300">
          HVAC refers to systems that regulate <strong>temperature</strong>,
          <strong> airflow</strong>, <strong>humidity</strong>, and
          <strong> indoor air quality</strong> in buildings. It is no longer a
          luxury — it is critical infrastructure.
        </p>
      </section>

      {/* Where HVAC Exists */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-white flex items-center gap-2 mb-4">
          <i className="fa-solid fa-location-dot text-green-400"></i>
          HVAC in Daily Life
        </h2>

        <ul className="grid grid-cols-2 gap-3 text-sm text-gray-300 [&>li]:text-white">
          <li className="flex items-center gap-2">
            <i className="fa-solid fa-house text-orange-400"></i> Homes
          </li>
          <li className="flex items-center gap-2">
            <i className="fa-solid fa-building text-orange-400"></i> Offices
          </li>
          <li className="flex items-center gap-2">
            <i className="fa-solid fa-hospital text-orange-400"></i> Hospitals
          </li>
          <li className="flex items-center gap-2">
            <i className="fa-solid fa-cart-shopping text-orange-400"></i> Malls
          </li>
          <li className="flex items-center gap-2">
            <i className="fa-solid fa-industry text-orange-400"></i> Factories
          </li>
          <li className="flex items-center gap-2">
            <i className="fa-solid fa-server text-orange-400"></i> Data Centers
          </li>
        </ul>
      </section>

      {/* Why HVAC Matters */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-white flex items-center gap-2 mb-3">
          <i className="fa-solid fa-bolt text-yellow-400"></i>
          Why HVAC Matters
        </h2>

        <div className="space-y-3 text-sm text-gray-300 [&>p]:text-white">
          <p>• Controls 30–60% of building energy consumption</p>
          <p>• Direct impact on climate change & carbon emissions</p>
          <p>• Critical for health, infection control & productivity</p>
          <p>• Foundation of smart buildings & ESG compliance</p>
        </div>
      </section>

      {/* Technology Shift */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-white flex items-center gap-2 mb-4">
          <i className="fa-solid fa-microchip text-purple-400"></i>
          HVAC is Becoming DeepTech
        </h2>

        <div className="grid grid-cols-2 gap-3 text-sm text-gray-300">
          <div className="flex items-center gap-2">
            <i className="fa-solid fa-brain text-cyan-400"></i> AI Optimization
          </div>
          <div className="flex items-center gap-2">
            <i className="fa-solid fa-wifi text-cyan-400"></i> IoT & Sensors
          </div>
          <div className="flex items-center gap-2">
            <i className="fa-solid fa-cube text-cyan-400"></i> Digital Twins
          </div>
          <div className="flex items-center gap-2">
            <i className="fa-solid fa-leaf text-cyan-400"></i> Low-GWP Refrigerants
          </div>
        </div>
      </section>

      {/* Sustainability */}
      <section className="mb-10">
        <h2 className="text-xl font-semibold text-white flex items-center gap-2 mb-3">
          <i className="fa-solid fa-earth-asia text-emerald-400"></i>
          HVAC & Sustainability
        </h2>
        <p className="text-sm leading-relaxed text-white">
          No <strong>Net-Zero Building</strong> is possible without intelligent
          HVAC. The sector carries responsibility for energy efficiency,
          emissions reduction, indoor air quality, and long-term ESG reporting.
        </p>
      </section>

      {/* Footer Note */}
      <footer className="border-t border-gray-800 pt-4">
        <p className="text-xs text-white text-center">
          HVAC is no longer just engineering — it is climate action,
          infrastructure, and digital intelligence combined.
        </p>
      </footer>
    </div>
  );
};

export default HVACAbout;
